import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import { getMonthlyReport } from './actions';
import { MonthlyReportAction, MonthlyReportState } from './types';

export const INITIAL_STATE: MonthlyReportState = {
  loading: false,
  report: undefined,
  error: false,
};

const reducer: Reducer<MonthlyReportState, MonthlyReportAction> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case getType(getMonthlyReport.request):
      return {
        ...state,
        loading: true,
        error: false,
      };
    case getType(getMonthlyReport.success):
      return {
        ...state,
        loading: false,
        error: false,
        report: action.payload,
      };
    case getType(getMonthlyReport.failure):
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

export default reducer;
